import { useTRPCAPI, useTRPCQuery } from '../../../trpc/trpc';
import { useShareTokenInput } from './useShareTokenInput';

interface UseTrackRecentPlaylistChangesProps {
  trackId: string;
  endDate?: Date;
  days: number;
  perDayLimit?: number;
}

export const useTrackRecentPlaylistChanges = ({
  trackId,
  endDate,
  days,
  perDayLimit = 10,
}: UseTrackRecentPlaylistChangesProps) => {
  const trpcMusicAPI = useTRPCAPI();
  const shareTokenInput = useShareTokenInput();

  return useTRPCQuery(
    trpcMusicAPI.tracks.recentPlaylistChanges.queryOptions({
      trackId,
      endDate,
      days,
      perDayLimit,
      ...shareTokenInput,
    })
  );
};
